import { languageMenuStyles } from "@insite/content-library/Widgets/Common/LanguageMenu";
import Globe from "@insite/mobius/Icons/Globe";
import { css } from "styled-components";

languageMenuStyles.languageIcon = {
    size: 15,
    src: Globe,
    css: css`
        margin-top: -3px;
    `,
};
languageMenuStyles.languageSelect = {
    sizeVariant: "small",
    backgroundColor: "transparent",
    cssOverrides: {
        formInputWrapper: css`
            width: 72px;
            &&&& select {
                padding: 0;
            }
        `,
        inputSelect: css`
            border-color: transparent;
            text-transform: capitalize;
            font-size: 14px !important;
        `,
    },
};
